import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";

export default function AdminShopOrders() {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/admin/shop-orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const cancel = async (id) => {
    if (!window.confirm("Cancel this order?")) return;
    await api.put(`/admin/shop-orders/${id}/cancel`);
    toast.success("Order cancelled");
    load();
  };

  const exportCsv = async () => {
    const token = localStorage.getItem("furshala_admin_token");
    const r = await fetch(`${api.defaults.baseURL}/admin/shop-orders/export`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = "furshala-shop-orders.csv"; a.click();
  };

  return (
    <div data-testid="admin-shop-orders">
      <div className="flex justify-between items-end mb-8 flex-wrap gap-4">
        <div>
          <h1 className="font-serif text-3xl text-brand-soft">Shop orders</h1>
          <p className="text-sm text-brand-soft/60 mt-1">All product purchases. Payment is verified server-side by Razorpay.</p>
        </div>
        <button onClick={exportCsv} className="btn-outline-furshala inline-flex items-center gap-2 text-sm py-2"><Download className="w-4 h-4" /> CSV</button>
      </div>

      <div className="bg-white rounded-2xl border border-brand-maroon/10 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-brand-ivory text-brand-soft/70">
              <tr>
                <Th>Product</Th>
                <Th>Buyer</Th>
                <Th>Qty × Price</Th>
                <Th>Total</Th>
                <Th>Status</Th>
                <Th>Address</Th>
                <Th>Created</Th>
                <Th>Actions</Th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 && <tr><td colSpan={8} className="p-8 text-center text-brand-soft/60 italic">No orders yet.</td></tr>}
              {orders.map((o) => (
                <tr key={o.id} className="border-t border-brand-maroon/5 align-top">
                  <Td>
                    <div className="flex gap-2 items-center">
                      {o.product_image && <img src={fileUrl(o.product_image)} alt="" className="w-10 h-10 rounded object-cover" />}
                      <div className="font-medium">{o.product_name}</div>
                    </div>
                  </Td>
                  <Td>
                    <div className="font-medium">{o.buyer_name}</div>
                    <div className="text-xs text-brand-soft/60">{o.email}</div>
                    <div className="text-xs text-brand-soft/60">{o.whatsapp_number}</div>
                  </Td>
                  <Td><div className="text-xs">{o.quantity} × ₹{o.unit_price}</div></Td>
                  <Td><div className="font-medium">₹{o.total_amount}</div></Td>
                  <Td>
                    <span className={`text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full ${
                      o.payment_status === "approved" ? "bg-brand-olive/20 text-brand-olive" :
                      o.payment_status === "cancelled" ? "bg-red-100 text-red-700" : "bg-brand-mustard/20 text-brand-maroon"
                    }`}>{o.payment_status}</span>
                    {o.payment_ref && <div className="text-[10px] text-brand-soft/50 mt-1 break-all">{o.payment_ref}</div>}
                  </Td>
                  <Td><div className="text-xs text-brand-soft/70 max-w-[200px] whitespace-pre-wrap">{o.address || <span className="text-brand-soft/40">—</span>}</div></Td>
                  <Td><div className="text-xs text-brand-soft/60">{new Date(o.created_at).toLocaleDateString()}</div></Td>
                  <Td>
                    {o.payment_status !== "cancelled" && (
                      <button onClick={() => cancel(o.id)} className="text-xs inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-red-50 text-red-700 hover:bg-red-100">
                        <X className="w-3 h-3" /> Cancel
                      </button>
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const Th = ({ children }) => <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">{children}</th>;
const Td = ({ children }) => <td className="px-4 py-3">{children}</td>;
